import styled from "styled-components";
import { colorGray } from "../../../../utils/palette";

// Styled components for table headers
export const ColumnHeaderContainer = styled.span`
  font-weight: 500;
  height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    cursor: pointer;
    span {
      color: ${colorGray} !important;
    }
  }
`;
